import React from 'react';
import dot from 'dot-object';
import ReactHtmlParser from 'react-html-parser';
import { repeatObjects, verifyConditional } from '../helper';

import Input from './input';
import { formatClassname } from 'datastake-daf/src/helpers/ClassesHelper';

const Group = ({
  name = null,
  config = {},
  data = {},
  allData = {},
  linkingData = {},
  linkingForms = {},
  ajaxOptions = [],
  cols = 4,
}) => {
  const label = () => {
    function getLabel(label) {
      switch (typeof label) {
        case 'string':
          return label;
        case 'object':
          const labelKey = Object.keys(label).find(cond =>
            verifyConditional(cond, data, allData));
          return label[labelKey];
        default:
          return JSON.stringify(label);
      }
    }
    if (config.sectionLabel) {
      return getLabel(config.sectionLabel);
    }
    if (config.outputLabel) {
      return getLabel(config.outputLabel);
    }
    return getLabel(config.label);
  }

  const dataConditions = () => {
    const condition = config.conditions ? Object.keys(config.conditions)[0] : null;
    if (!condition) {
      return null;
    }
    if (verifyConditional(condition, data, allData)) {
      const groupName = config.dataId ? config.dataId : name;
      try {
        Object.keys(config.conditions[condition]).forEach(key => {
          const [form, input] = config.conditions[condition][key].split('.inputs.');
          dot.str(`${groupName}.${key}`, dot.pick(`${form}.${input}`, data), data);
        });
        Object.keys(config.inputs).forEach(key => delete config.inputs[key].showIf);
        return data;
      } catch (e) {

      }
    }
    return null;
  }

  const inputsValues = Object.values(config.inputs);

  return (
    <div className="group">
      {label() ? (
        <div className={formatClassname(['title', (inputsValues && inputsValues[0] && inputsValues[0].showOnTitle) && 'title-with-tag'])}>
          <h1>{ReactHtmlParser(label())}</h1>
        </div>
      ) : null}
      {repeatObjects(config.inputs, (key) => {
        const dataId = config.inputs[key].dataId || key;
        return <Input
          linkingData={linkingData}
          key={key}
          parent={config.dataId ? config.dataId : name}
          name={dataId}
          config={config.inputs[key]}
          data={dataConditions() ? dataConditions() : data}
          allData={allData}
          linkingForms={linkingForms}
          cols={cols}
          ajaxOptions={ajaxOptions}>
        </Input>
      })}
    </div>
  );
}

export default Group;
